import React, { useState } from 'react';
import { gql, useMutation } from '@apollo/client';

export const VIEWER_UPDATE = gql`
    mutation UpdateViewer(
        $alternateAddress: AddressInput
        $birthdate: DateInput
        $blogUrl: String
        $cellPhone: String
        $description: String
        $displayPhoto: Boolean
        $displayEmail: Boolean
        $email: String
        $fax: String
        $firstCollege: College
        $firstGraduationYear: Int
        $functionalTitle: FunctionalTitle
        $gender: Gender
        $hideAddressFields: Boolean
        $homeAddress: AddressInput
        $informal: String
        $linkedinUrl: String
        $mainAddress: AddressInput
        $meetingInvites: Boolean
        $noCollege: Boolean
        $personalResponsibility: PersonalResponsibility
        $prefix: String
        $secondCollege: College
        $secondGraduationYear: Int
        $secondaryEmail: String
        $suffix: String
        $title: String
        $twitterUrl: String
        $workPhone: String
        $messages: Boolean
        $notifications: [NotificationPreference]
    ) {
        updateViewer(
            alternateAddress: $alternateAddress
            birthdate: $birthdate
            blogUrl: $blogUrl
            cellPhone: $cellPhone
            description: $description
            displayPhoto: $displayPhoto
            displayEmail: $displayEmail
            email: $email
            fax: $fax
            firstCollege: $firstCollege
            firstGraduationYear: $firstGraduationYear
            functionalTitle: $functionalTitle
            gender: $gender
            hideAddressFields: $hideAddressFields
            homeAddress: $homeAddress
            informal: $informal
            linkedinUrl: $linkedinUrl
            mainAddress: $mainAddress
            meetingInvites: $meetingInvites
            noCollege: $noCollege
            personalResponsibility: $personalResponsibility
            prefix: $prefix
            secondCollege: $secondCollege
            secondGraduationYear: $secondGraduationYear
            secondaryEmail: $secondaryEmail
            suffix: $suffix
            title: $title
            twitterUrl: $twitterUrl
            workPhone: $workPhone
            messages: $messages
            notifications: $notifications
        ) {
            ... on Viewer {
                id
                addresses(purpose: [MAIN, HOME, ALTERNATE]) {
                    purpose
                    address
                    address2
                    address3
                    city
                    stateProvince
                    country
                    purpose
                    zip
                    preferredMailing
                    preferredBilling
                }
                birthdate
                blogUrl
                cellPhone
                description
                designations
                displayPhoto
                displayEmail
                email
                fax
                firstCollege {
                    code
                    name
                }
                firstGraduationYear
                firstName
                gender
                informal
                lastName
                meetingInvites
                middleName
                functionalTitle
                linkedinUrl
                noCollege
                personalResponsibility
                prefix
                secondCollege {
                    code
                    name
                }
                secondGraduationYear
                secondaryEmail
                status
                suffix
                title
                twitterUrl
                workPhone
                messages
                notifications
            }

            ... on ErrorCollection {
                errors
            }
        }
    }
`;

const useViewerUpdate = ({ onCompleted, onError }) => {
    const [error, setError] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [isSuccessful, setIsSuccessful] = useState(false);
    const [updateMutate] = useMutation(VIEWER_UPDATE, {
        onCompleted: data => {
            if (data.updateViewer.errors && data.updateViewer.errors[0].toUpperCase().includes('EMAIL')) {
                handleError(data.updateViewer.errors[0]);
            } else {
                onComplete();
            }
        },
        onError: e => handleError(e),
    });

    const onComplete = () => {
        setIsLoading(false);
        setIsSuccessful(true);

        if (onCompleted) {
            onCompleted();
        }
    };

    const handleError = e => {
        setIsLoading(false);
        setError(e);
        if (onError) {
            onError(e);
        }
    };

    const updateViewer = React.useCallback(
        async ({ variables }) => {
            setIsLoading(true);
            await updateMutate({
                variables,
            });
        },
        [updateMutate]
    );

    return { isLoading, error, updateViewer, isSuccessful };
};

export default useViewerUpdate;
